import dayjs from 'dayjs'
import Vue from 'vue'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrAfter)

export default {
  active: function(_state, getters) {
    return () => getters.isConnected
  },
  oAuth2State: () => () => {
    const connectState = Vue.$cookies.get('SquareOAuth2ConnectState')
    if (connectState) {
      Vue.$cookies.remove('SquareOAuth2ConnectState')
    }
    return connectState
  },
  isConnected: function(state) {
    return !!(state.isConnected && state.isConnectedExpires && dayjs(state.isConnectedExpires).isSameOrAfter(new Date()))
  },
  tokenExpires: function(state, getters) {
    return getters.isConnected ? state.tokenExpires : null
  },
  appID: function(state, getters) {
    return getters.testMode ? 'sandbox-sq0idb-BvbUajMFlX-C_2uKWqcS0w' : 'sq0idp-o7upiNKgVVNq6eblil9EBA'
  },
  locationID: function(state, getters) {
    return getters.testMode ? 'L5TPWFJBPJPWV' : state.location
  },
  testMode: function(state, getters, rootState, rootGetters) {
    if (state.mode === 'development') {
      return true
    }
    else {
      try {
        if (rootGetters['ecommerce/getConfigItem']('square_payments', 'testmode')) {
          return true
        }
        return false
      }
      catch (e) {
        return false
      }
    }
  },
  processingResult: function(state) {
    return state.processingResult
  },
  currencyCode: function(state) {
    return state.currencyCode || 'AUD'
  },
  selectedTerminalDevice: function(state) {
    if (!state.selectedTerminalDeviceId) return null
    return state.terminalDeviceCodes.find(device =>
      device.device_id === state.selectedTerminalDeviceId && device.status === 'PAIRED'
    ) || null
  },
  pairedTerminalDevices: function(state) {
    return state.terminalDeviceCodes.filter(device => device.status === 'PAIRED')
  },
  hasSelectedTerminalDevice: function(state, getters) {
    return !!getters.selectedTerminalDevice
  },
  terminalConnected: function(state, getters) {
    return getters.isConnected && getters.hasSelectedTerminalDevice
  },
  terminalPaymentPending: function(state) {
    return state.terminalPaymentProcessing
  },
  AcceleratedTransactionsHandler: function(state, _getters, _rootState, rootGetters) {
    return (funcName) => {
      if (rootGetters.AcceleratedTransactions && state.AcceleratedTransactionHandler && typeof state.AcceleratedTransactionHandler[funcName] === 'function') {
        return state.AcceleratedTransactionHandler[funcName]
      }
      return false
    }
  }
}
